import React from 'react';
import '../user/AboutPAPT.css';  // Import the corresponding CSS file for styling

const transport = () => {
  return (
    <div className="about-container">
      <div className="content">
        <h1>OUR LIBRARY</h1>
        <div className="yellow-line1"></div>
        <p>


        P. A. Polytechnic Library and information center is not only mere treasure house of information but also laboratory of knowledge and nerve center of intellectual activity of our institution. It is located in spacious Independent block with area of 11,500 sq.ft.

At present the library has 30,264 volumes of books covering all branches of engineering and reference books like encyclopedia, hand books, dictionaries, GATE, GRE books & literature books. In addition to the library 782 project reports, 1033 bound volumes of journals and also ITDP Book bank collection of 1019 books.


        </p>
       
      </div>
      <div className="ed">
        <img src="/images/lib.jpg" />
      </div>
    </div>
  );
};

export default transport;
